import { render, staticRenderFns } from "./PageForgotPassword.vue?vue&type=template&id=0d30e8a8&scoped=true&"
import script from "./PageForgotPassword.vue?vue&type=script&lang=js&"
export * from "./PageForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d30e8a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d30e8a8')) {
      api.createRecord('0d30e8a8', component.options)
    } else {
      api.reload('0d30e8a8', component.options)
    }
    module.hot.accept("./PageForgotPassword.vue?vue&type=template&id=0d30e8a8&scoped=true&", function () {
      api.rerender('0d30e8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/forgotpassword/PageForgotPassword.vue"
export default component.exports